import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';


import AuthReducer from '../components/auth/auth_reducer';
import ProjectReducer from '../components/project/project_reducer';
import ProfileReducer from '../components/profile/profile_reducer';
import TimerReducer from '../components/timetracker/timer_reducer';
import ScheduleReducer from '../components/schedule/schedule_reducer';
import CalendarReducer from '../components/calendar/calendar_reducer';
import CommonReducer from '../common/common_reducer';
import EditorReducer from '../components/document-editor/editor_reducer';
import MessengerReducer from '../components/messenger/messenger_reducer';


const rootReducer = combineReducers({
  auth: AuthReducer,
  projects: ProjectReducer,
  profile: ProfileReducer,
  timer: TimerReducer,
  form: formReducer,
  schedule: ScheduleReducer,
  calendar: CalendarReducer,
  common: CommonReducer,
  editor: EditorReducer,
  messenger: MessengerReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/_reducers/reducers.js